import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { toggleTutorialStartDialog, toggleTutorialAction } from '../../actions/tutorial-actions';
import { closeEntireAccordion } from '../../actions/accordion-actions';

class ToggleTutorialDialog extends PureComponent {
  closeModal = () => {
    this.props.toggleTutorialStartDialog(false);
  };

  toggleTutorial = (toggle) => {
    this.props.closeEntireAccordion();
    setTimeout(() => {
      this.props.toggleTutorialAction(toggle);
    }, 310);
  };

  render() {
    const { lang, content, showTutorialStartDialog } = this.props;

    return (
      <Dialog
        header="StormGenie Design Tool Tour" // Static title
        visible={showTutorialStartDialog}
        style={{ width: '50vw' }}
        onHide={this.closeModal}>
        <div>
          <p
            dangerouslySetInnerHTML={{
              __html: content[lang].tutorialStartText,
            }}></p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            <Button
              label="Ok"
              style={{ backgroundColor: 'rgb(12, 146, 205)' }}
              onClick={() => {
                this.toggleTutorial(true);
                this.closeModal();
              }}
            />
            <Button
              label="Cancel"
              style={{ backgroundColor: 'rgb(12, 146, 205)' }}
              onClick={() => {
                console.log('Cancel clicked');
                this.closeModal();
              }}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,
    showTutorialStartDialog: state.tutorial.toggleTutorialStartDialog,
  };
};

const mapDispatchToProps = {
  toggleTutorialStartDialog,
  toggleTutorialAction,
  closeEntireAccordion,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleTutorialDialog);



// WEBPACK FOOTER //
// ./src/components/Tutorial/tutorialStartDialog.js